<template>
    <div class="dmapp">
        <template v-if="maintenance">
            <v-app>
                <v-img src="@/assets/img/bg/bg1-min.jpg" class="dm-bg" position="center top"></v-img>
                <v-content>
                    <v-container>
                        <v-row align="center" justify="center">
                            <v-col cols="12" sm="11" md="10" align-self="center">
                                <v-container>
                                        <v-row justify="center">
                                            <v-col cols="auto">
                                                <v-card>
                                                    <v-card-title>Application en maintenance</v-card-title>
                                                    <v-card-text>
                                                        <p>Nous sommes actuellement en train d'améliorer l'application, qui sera de retour prochainement.</p>
                                                        <p>Merci de votre compréhension !</p>
                                                    </v-card-text>
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                </v-container>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-content>
            </v-app>
        </template>
        <template v-else>
            <router-view />
        </template>
    </div>
</template>

<script>
  import Vue from 'vue'
  export default {
    name: 'App',
    data: () => ({
      cordova: Vue.cordova,
      isCordovaReady: false,
      maintenance: false
    }),
    created () {
      var self = this
      this.cordova.on('deviceready', () => {
        self.onDeviceReady()
        self.isCordovaReady = true
      })
    },
    updated () {
      if (!window.localStorage.token) {
        if (this.$router.history.current.name != 'Inscription' && this.$router.history.current.name != 'Connexion') {
          this.$router.push('Connexion')
        }
      }
    },
    methods: {
      onDeviceReady () {
        this.$store.commit('SET_PLATFORM', this.cordova.device.platform)
        this.cordova.on('pause', this.onPause, false)
        this.cordova.on('resume', this.onResume, false)
        if (this.cordova.device.platform === 'Android') {
          document.addEventListener('backbutton', this.onBackButton, false)
        }
      },
      onPause () {
        // console.log('pause')
      },
      onResume () {
        // SetTimeout required for iOS.
        setTimeout(() => {
          // console.log('resume')
        }, 0)
      },
      onBackButton () {
        navigator.app.backHistory()
        // this.exitApp()
      },
      exitApp () {
        navigator.app.exitApp()
      }
    }
  }
</script>

<style lang="css">
  @import "assets/style/theme.css";
  @import "assets/style/base.css";
</style>